import React from 'react';
import { StatusPills } from 'components/StatusPills/StatusPills';
import { Appearance } from 'design/types';
import { IPayoutStats, PayoutStatus } from 'types';
import { sumBy } from 'utils/arrays';

interface IPaymentStatusPillsProps {
  payoutStats?: IPayoutStats;
  isLoading?: boolean;
  activeStatuses?: string[];
  onStatusChange?(selectedStatus: string[]): void;
}

export const PaymentStatusPills: React.FC<IPaymentStatusPillsProps> = ({ payoutStats, isLoading = false, activeStatuses, onStatusChange }) => {
  const paidCount = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PAID),
    'count'
  );
  const paidTotal = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PAID),
    'net'
  );

  const pendingCount = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PENDING),
    'count'
  );
  const pendingTotal = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PENDING),
    'net'
  );

  const expiredCount = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.EXPIRED),
    'count'
  );
  const expiredTotal = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.EXPIRED),
    'net'
  );

  const canceledCount = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.CANCELED),
    'count'
  );
  const canceledTotal = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.CANCELED),
    'net'
  );

  const payrollCount = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PAYROLL),
    'count'
  );
  const payrollTotal = sumBy(
    (payoutStats?.byStatus || []).filter((s) => s.status === PayoutStatus.PAYROLL),
    'net'
  );

  return (
    <StatusPills
      statuses={[
        { label: PayoutStatus.PAID, value: paidTotal, count: paidCount, appearance: Appearance.SUCCESS },
        { label: PayoutStatus.PAYROLL, value: payrollTotal, count: payrollCount, appearance: Appearance.SECONDARY },
        { label: PayoutStatus.PENDING, value: pendingTotal, count: pendingCount, appearance: Appearance.WARNING },
        { label: PayoutStatus.EXPIRED, value: expiredTotal, count: expiredCount, appearance: Appearance.DANGER },
        { label: PayoutStatus.CANCELED, value: canceledTotal, count: canceledCount, appearance: Appearance.NEUTRAL },
      ]}
      isLoading={isLoading}
      activeStatuses={activeStatuses}
      onChange={(s: string[]) => onStatusChange?.(s)}
    />
  );
};
